import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use timeout to allow page content to render
    const timeout = setTimeout(() => {
      // Fallback to instant scroll for better reliability
      window.scrollTo({ top: 0, behavior: "auto" });
    }, 100);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
